import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Button,
  TextField,
  Paper,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getInvoiceObject,
  generateDocument,
} from "../../api/api-backend/myinvois_api";
import { Label } from "@mui/icons-material";

// Common form component
const NoteForm = ({ noteType }) => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { user } = useContext(AuthContext);
  const [documentId, setDocumentId] = useState(uuid);
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [document, setDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [invoiceLines, setInvoiceLines] = useState([]);
  const [taxExclusiveAmount, setTaxExclusiveAmount] = useState(0);
  const setInvoiceLine = (index, field, value) => {
    var newInvoiceLines = [...invoiceLines];
    newInvoiceLines[index][field].Value = value;
    setInvoiceLines(newInvoiceLines);
  };
  
  const generateInvoiceObjectFields = (document) => {
    /**
     * {"DocumentID":{"SchemeID":null,"SchemeAgencyID":null,"Value":"INVU4103"},"IssueDate":"2024-08-19","IssueTime":"08:16:33Z","InvoiceTypeCode":{"ListVersionID":"1.0","Value":"01"},"TaxCurrencyCode":null,"DocumentCurrencyCode":"MYR","InvoicePeriod":null,"BillingReference":[],"AdditionalDocumentReference":[{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":null},"DocumentType":null,"DocumentDescription":null},{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":null},"DocumentType":null,"DocumentDescription":null},{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":null},"DocumentType":null,"DocumentDescription":null},{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":null},"DocumentType":null,"DocumentDescription":null}],"AccountingSupplierParty":{"AdditionalAccountID":null,"Party":{"IndustryClassificationCode":{"Name":"Provide system software","Value":"62021"},"PartyIdentification":[{"ID":{"SchemeID":"BRN","SchemeAgencyID":null,"Value":"202001004495"}},{"ID":{"SchemeID":"TIN","SchemeAgencyID":null,"Value":"C29990747030"}},{"ID":{"SchemeID":"SST","SchemeAgencyID":null,"Value":"NA"}},{"ID":{"SchemeID":"TTX","SchemeAgencyID":null,"Value":"NA"}}],"PostalAddress":{"CityName":"PJ","PostalZone":null,"CountrySubentityCode":"11","AddressLine":[{"Line":"Empire city"}],"Country":{"IdentificationCode":{"ListID":"ISO3166-1","ListAgencyID":"6","Value":"MYS"}}},"PartyLegalEntity":{"RegistrationName":"Ednatronics Sdn. Bhd"},"Contact":{"Telephone":"+60149686534","ElectronicMail":"hello@elona.tech"}}},"AccountingCustomerParty":{"Party":{"IndustryClassificationCode":null,"PartyIdentification":[{"ID":{"SchemeID":"NRIC","SchemeAgencyID":null,"Value":"910620075365"}},{"ID":{"SchemeID":"TIN","SchemeAgencyID":null,"Value":"IG25444963080"}},{"ID":{"SchemeID":"SST","SchemeAgencyID":null,"Value":"NA"}}],"PostalAddress":{"CityName":"PJ","PostalZone":null,"CountrySubentityCode":"11","AddressLine":[{"Line":"Empire city"}],"Country":{"IdentificationCode":{"ListID":"ISO3166-1","ListAgencyID":"6","Value":"MYS"}}},"PartyLegalEntity":{"RegistrationName":"Usher"},"Contact":{"Telephone":"+60149686534","ElectronicMail":"asharudin@elona.tech"}}},"Delivery":null,"PaymentMeans":null,"PaymentTerms":null,"PrepaidPayment":null,"AllowanceCharge":[],"TaxTotal":{"TaxAmount":{"CurrencyID":"MYR","Value":"9.80"},"TaxSubtotal":[{"TaxableAmount":{"CurrencyID":"MYR","Value":"98.00"},"TaxAmount":{"CurrencyID":"MYR","Value":"9.80"},"Percent":null,"BaseUnitMeasure":null,"PerUnitAmount":null,"TaxCategory":{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":"01"},"TaxExemptionReason":null,"TaxScheme":{"ID":{"SchemeID":"UN/ECE 5153","SchemeAgencyID":"6","Value":"OTH"}}}}]},"LegalMonetaryTotal":{"LineExtensionAmount":{"CurrencyID":"MYR","Value":"0"},"TaxExclusiveAmount":{"CurrencyID":"MYR","Value":"98"},"TaxInclusiveAmount":{"CurrencyID":"MYR","Value":"107.8"},"AllowanceTotalAmount":{"CurrencyID":"MYR","Value":"0"},"ChargeTotalAmount":{"CurrencyID":"MYR","Value":"0"},"PayableRoundingAmount":{"CurrencyID":"MYR","Value":"0"},"PayableAmount":{"CurrencyID":"MYR","Value":"0"}},"InvoiceLine":[{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":"001"},"InvoicedQuantity":{"UnitCode":"C62","Value":"1"},"LineExtensionAmount":{"CurrencyID":"MYR","Value":"98.00"},"AllowanceCharge":[],"TaxTotal":{"TaxAmount":{"CurrencyID":"MYR","Value":"9.8"},"TaxSubtotal":[{"TaxableAmount":{"CurrencyID":"MYR","Value":"98.00"},"TaxAmount":{"CurrencyID":"MYR","Value":"9.8"},"Percent":{"Value":"10.00"},"BaseUnitMeasure":null,"PerUnitAmount":null,"TaxCategory":{"ID":{"SchemeID":null,"SchemeAgencyID":null,"Value":"01"},"TaxExemptionReason":null,"TaxScheme":{"ID":{"SchemeID":"UN/ECE 5153","SchemeAgencyID":"6","Value":"OTH"}}}}]},"Item":{"Description":"IT services New","OriginCountry":null,"CommodityClassification":[{"ItemClassificationCode":{"ListID":"CLASS","Value":"023"}}]},"Price":{"PriceAmount":{"Value":"98.00","CurrencyID":"MYR"}},"ItemPriceExtension":{"Amount":{"CurrencyID":"MYR","Value":"98.00"}}}],"TaxExchangeRate":null}
     */
    //get invoice line list and return value as input fields
    //   var invoiceLine = document.InvoiceLine;
    //   var fields = [];
    //  ;
  };

  useEffect(() => {
    const fetchInvoiceObject = async () => {
      try {
        // Fetch invoice object
        var response = await getInvoiceObject(user.orgId, documentId);
        setDocument(response);
        setInvoiceLines(response.InvoiceLine);
        setTaxExclusiveAmount(response.LegalMonetaryTotal.TaxExclusiveAmount.Value);
      } catch (err) {
        console.error("Error fetching invoice object:", err);
        alert(`Error fetching invoice object: ${err.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    if (isLoading) {
      fetchInvoiceObject();
    }
  }, [documentId, isLoading, user.orgId]);

  const allowedFields = {
    CreditNote: ["amount", "description"],
    DebitNote: ["amount", "description"],
    RefundNote: ["description"],
  };

  const getTitle = (noteType, id) => {
    switch (noteType) {
      case "CreditNote":
        return "New Credit Note for Invoice " + id;
      case "DebitNote":
        return "New Debit Note for Invoice " + id;
      case "RefundNote":
        return "New Refund Note for Invoice " + id;
      default:
        return "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      // Handle form submission logic here
      switch (noteType) {
        case "CreditNote":
          // Handle new credit note submission
          var responseCreditNote = await generateDocument(
            user.orgId,
            documentId,
            "CreditNote",
            {
              invoiceLine: invoiceLines,
              taxExclusiveAmount: taxExclusiveAmount,
              description,
            }
          );
          console.log('responseCreditNote', responseCreditNote);
          alert(`Credit note for submitted for invoice ${documentId}`);
          navigate(`/creditnote/submissions/`);
          //navigate(`/creditnote/submissions/${responseCreditNote.submissionUid}/organization/${user.orgId}`);
          break;
        case "DebitNote":
          // Handle new debit note submission
          var responseDebitNote = await generateDocument(
            user.orgId,
            documentId,
            "DebitNote",
            {
              invoiceLine: invoiceLines,
              taxExclusiveAmount: taxExclusiveAmount,
              description,
            }
          );
          console.log('responseDebitNote', responseDebitNote);
          alert(`Debit note for submitted for invoice ${documentId}`);
          navigate(`/debitnote/submissions/`);
          //navigate(`/debitnote/submissions/${responseDebitNote.submissionUid}/organization/${user.orgId}`);
          break;
        case "RefundNote":
          // Handle new refund note submission
          var responseRefundNote = await generateDocument(
            user.orgId,
            documentId,
            "RefundNote",
            {
              description,
            }
          );
          console.log('responseRefundNote', responseRefundNote);
          alert(`Refund note for submitted for invoice ${documentId}. New document ID: ${responseRefundNote.submissionUid}`);
          navigate(`/refundnote/submissions/`);
          //navigate(`/refundnote/submissions/${responseRefundNote.submissionUid}/organization/${user.orgId}`);
          break;
        default:
          alert(`Invalid note type: ${noteType}`);
          return;
      }
      console.log(`${noteType} submitted`, {
        documentId,
        date,
        amount,
        description,
      });
    } catch (err) {
      console.error("Error submitting note:", err);
      alert(`Error submitting ${noteType}: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h5">{getTitle(noteType, documentId)}</Typography>
        </Grid>
        <Grid item xs={12}>
          {noteType === "CreditNote" ? (
            <>
              <p>
                <Typography variant="body1">
                  Credit note is the document issued by Suppliers to correct
                  errors, apply discounts, or account for returns in a
                  previously issued e-Invoice with the purpose of reducing the
                  value of the original e-Invoice. This is used in situations
                  where the reduction of the original e-Invoice does not involve
                  return of monies to the Buyer
                </Typography>
              </p>
              <p>
                <Typography variant="body1">
                  Please indicate the amount of correction that you want to
                  apply as credit note
                </Typography>
              </p>
            </>
          ) : null}
          {noteType === "DebitNote" ? (
            <>
              <p>
                <Typography variant="body1">
                  Debit note is the document issued to indicate additional
                  charges on a previously issued e-Invoice
                </Typography>
              </p>
              <p>
                <Typography variant="body1">
                  Please indicate the amount of correction that you want to
                  apply as debit note
                </Typography>
              </p>
            </>
          ) : null}
          {noteType === "RefundNote" ? (
            <>
              <p>
                <Typography variant="body1">
                  Refund note is the document issued by a Supplier to confirm
                  the refund of the Buyer’s payment. This is used in situations
                  where there is a return of monies to the Buyer
                </Typography>
              </p>
            </>
          ) : null}
        </Grid>
        {/* {allowedFields[noteType].includes("date") ? (
          <Grid item xs={12}>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Grid>
        ) : null} */}
        {
        invoiceLines &&
        invoiceLines.length > 0 &&
        ["CreditNote", "DebitNote"].indexOf(noteType) >= 0
          ? invoiceLines.map((line, index) => (
              <>
                {/* Invoice line item */}
                <Grid item xs={4}>
                  <Typography variant="body1">
                    Invoice Line {index + 1}
                  </Typography>
                </Grid>
                {/* <Grid item xs={3}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Description"
                    value={line.Description}
                    onChange={(e) => setInvoiceLine(index, "Description", e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={4}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Invoiced Quantity"
                    value={line.InvoicedQuantity.Value}
                    onChange={(e) => setInvoiceLine(index, "InvoicedQuantity", e.target.value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Line Extension Amount"
                    value={line.LineExtensionAmount.Value}
                    onChange={(e) => setInvoiceLine(index, "LineExtensionAmount", e.target.value)}
                  />
                </Grid>
              </>
            ))
          : null}
          {
            ["CreditNote", "DebitNote"].indexOf(noteType) >= 0 ? (
              <>
                 {/* Main Invoice Total */}
                 {/* <Grid item xs={6}>
                  <Typography variant="body1">
                    Invoice Total
                  </Typography>
                </Grid> */}
                {/* <Grid item xs={6}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Line Extension Amount"
                    value={document.LegalMonetaryTotal.LineExtensionAmount.Value}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <Typography variant="body1">
                    Tax Exclusive Amount
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Tax Exclusive Amount"
                    value={taxExclusiveAmount}
                    onChange={(e) => setTaxExclusiveAmount(e.target.value)}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <Typography variant="body1">
                    Tax Inclusive Amount
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    label="Tax Inclusive Amount"
                    value={document.LegalMonetaryTotal.TaxInclusiveAmount.Value}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid> */}
              </>
            ) :null
          }
        {["CreditNote", "DebitNote", "RefundNote"].indexOf(noteType) >= 0 ? (
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary">
            {isLoading ? <CircularProgress size={24} /> : "Submit"}
          </Button>
        </Grid>
      </Grid>
      {/* <div>
        <label>Document Id:</label>
        <input
          type="text"
          value={documentId}
          onChange={(e) => setDocumentId(e.target.value)}
        />
      </div> */}
    </form>
  );
};
// Make sure have Back button and Submit button for all cases

const NewCreditNotePage = () => {
  /**
     * credit note
        Credit note is the document issued by Suppliers to correct errors, apply discounts, or account for returns in a previously issued e-Invoice with the purpose of reducing the value of the original e-Invoice. This is used in situations where the reduction of the original e-Invoice does not involve return of monies to the Buyer
        Please indicate the amount of correction that you want to apply as credit note
        [text field to indicate value] 
    */
  const navigate = useNavigate();

  return (
    <>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
      >
        Back
      </Button>
      <Paper
        style={{ padding: "20px", maxWidth: "800px", margin: "20px auto" }}
      >
        <NoteForm noteType="CreditNote" />
      </Paper>
    </>
  );
};

const NewDebitNotePage = () => {
  /**
     * debit note
        Debit note is the document issued to indicate additional charges on a previously issued e-Invoice. 
        This is used in situations where the increase of the original e-Invoice does not involve additional payment from the Buyer
        Please indicate the amount of correction that you want to apply  as debit note
        [text field to indicate value]
    */
  const navigate = useNavigate();

  return (
    <>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
      >
        Back
      </Button>
      <Paper
        style={{ padding: "20px", maxWidth: "800px", margin: "20px auto" }}
      >
        <NoteForm noteType="DebitNote" />
      </Paper>
    </>
  );
};

const NewRefundNotePage = () => {
  /**
     * Refund note
        Refund note is the document issued by a Supplier to confirm the refund of the Buyer’s payment. 
        This is used in situations where there is a return of monies to the Buyer
     */
  const navigate = useNavigate();

  return (
    <>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
      >
        Back
      </Button>
      <Paper
        style={{ padding: "20px", maxWidth: "800px", margin: "20px auto" }}
      >
        <NoteForm noteType="RefundNote" />
      </Paper>
    </>
  );
};

export { NewCreditNotePage, NewDebitNotePage, NewRefundNotePage };
